<template>
  <div class="row">
    <div class="col-md-12">
      <DataTable
        ref="datatable"
        :width="'100%'"
        :settings="datatable.settings"
        :dataColumns="datatable.columns"
        :dataFeed="datatable.dataFeed"
        :dataHandle="datatable.handle"
        :dataTableHeight="datatable.height"
        :defaultSortBy="datatable.sortBy"
        :defaultOrderBy="datatable.orderBy"
        :allowView="allowView"
        :allowEdit="allowEdit"
        :allowDelete="allowDelete"
        :hasContextMenu="hasContextMenu"
      >
        <template slot="menuButtons" slot-scope="props">
          <template v-if="props.item && props.item.data">
            <li
              @click="$refs.datatable.viewItem($event, props.item.data)"
              v-if="allowView(props.item.data)"
            >View</li>
            <li
              @click="$refs.datatable.editItem($event, props.item.data)"
              v-if="allowEdit(props.item.data)"
            >Edit</li>
            <li
              @click="$refs.datatable.confirmDelete($event, props.item.data)"
              v-if="allowDelete(props.item.data)"
            >Delete</li>
          </template>
        </template>
      </DataTable>
      <!-- END DATA TABLE -->
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {
      pageSettings: {
        pageTitle: 'Project',
        sectionName: 'project',
        sectionIcon: 'fab fa-buffer',
        type: this.pageType,
        useDefault: false,
        webService: this.$root.WebService.project,
        navigation: [
          { name: 'Project', route: 'project.index' },
        ],
        buttons: [],
        subSidebar: {
          buttons: [
            { name: 'Vendor Project', icon: 'fas fa-file-download', action: () => { this.$router.push({ name: 'vendorproject.index' }) } },
            { name: 'Project', icon: 'fab fa-buffer', action: () => { this.$router.push({ name: 'project.index' }) } },
          ]
        }
      },
      datatable: {
        settings: {
          sectionName: 'project',
          webService: this.$root.WebService.project,
        },
        dataFeed: null,
        handle: null,
        columns: [
          { key: 'created_at', title: 'Created At', type: 'datepicker', width: '10%', value: { from: null, to: null }, datafilter: this.$options.filters.dateFormat },
          { key: 'project_code', title: 'Project No', type: 'input', width: '10%', value: null },
          { key: 'customer_name', title: 'Customer', type: 'input', width: '20%', value: null },
          { key: 'remarks', title: 'Project Description', type: 'input', width: '60%', value: null },
        ],
        sortBy: null,
        orderBy: 'desc',
        width: '100%',
        height: '70vh',
      },
      datas: [],
      userRoles: [],
      selectedProject: null
    }
  },
  created() {

  },
  mounted() {

    if (this.hasPermission('create project')) this.pageSettings.buttons.push({ name: 'Add New Project', icon: 'fas fa-plus', action: this.addItem })

    this.$emit('setPageHeader', this.pageSettings)
    this.datatable.handle = (res) => this.datas = res.data.data
    this.datatable.dataFeed = {
      method: 'get',
      url: this.pageSettings.webService
    }
  },
  methods: {
    addItem() {
      this.$router.push({ name: this.pageSettings.sectionName + '.create' })
    },
    exportData() {

    },
    importData() {

    },
    allowView(item) {
      return this.hasPermission('read project')
    },
    allowEdit(item) {
      return this.hasPermission('update project')
    },
    allowDelete(item) {
      return this.hasPermission('delete project') && false
    },
    hasContextMenu(item) {
      return this.allowView(item) || this.allowEdit(item) || this.allowDelete(item)
    }
  }
}
</script>